import { ClerkProvider } from '@clerk/clerk-react';

// Get the publishable key from environment variables
const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!clerkPublishableKey) {
  console.warn('Missing Clerk publishable key. Please add VITE_CLERK_PUBLISHABLE_KEY to your environment variables.');
}

// Validate the key format
if (clerkPublishableKey && !clerkPublishableKey.startsWith('pk_')) {
  console.error('Invalid Clerk publishable key format. Key should start with "pk_"');
}

export { ClerkProvider, clerkPublishableKey };
